import React, { useRef, useState } from "react";
import "./CareerSection.css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

export const GradIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Courses-black.svg"
      : "/Image/Hero/Courses.svg";

  return <img src={src} alt="grad icon" width={size} height={size} />;
};

export const BriefcaseIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Jobs-black.svg"
      : "/Image/Hero/Jobs.svg";

  return <img src={src} alt="briefcase icon" width={size} height={size} />;
};

export const ProfileIcon = ({ size, color = "white" }) => {
  const src =
    color === "black"
      ? "/Image/Hero/Profile-black.svg"
      : "/Image/Hero/Profile.svg";

  return <img src={src} alt="profile icon" width={size} height={size} />;
};

export const TickIcon = () => {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        backgroundColor: "#EE2F75",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      aria-hidden="true"
    >
      <img src="/Image/Hero/Tick2.svg" width="14" height="14" alt="" />
    </div>
  );
};

export default function CareerSection() {
  const { t } = useTranslation();
  const history = useHistory();
  const videoRef = useRef(null);

  const [active, setActive] = useState("courses");
  const [direction, setDirection] = useState("right");
  const [showThumbnail, setShowThumbnail] = useState(true);

  const thumbnails = {
    courses: "/Image/Hero/course-thumb.jpg",
    jobs: "/Image/Hero/job-thumb.jpg",
    profile: "/Image/Hero/profile-thumb.jpg",
  };


  const tabOrder = {
    courses: 0,
    jobs: 1,
    profile: 2,
  };

  const handleTabChange = (nextTab) => {
    if (nextTab === active) return;

    const currentIndex = tabOrder[active];
    const nextIndex = tabOrder[nextTab];

    setDirection(nextIndex > currentIndex ? "right" : "left");
    setActive(nextTab);

    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }

    setShowThumbnail(true);
  };
  
  const handlePlay = () => {
    setShowThumbnail(false);
    requestAnimationFrame(() => {
      videoRef.current?.play();
    });
  };

  const handleLearnMore = () => {
    history.push({
      pathname: "/signup",
      state: { detail: "INDIVIDUAL" },
    });
  };

  const videoLinks = {
    courses:
      "https://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/course%20feature.m4v",
    jobs:
      "https://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/Job%20feature.m4v",
    profile:
      "https://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/Profile%20video.m4v",
  };

  const renderContent = () => {
    switch (active) {
      case "courses":
        return {
          title: t("home.career.courses.title"),
          desc: t("home.career.courses.desc"),
          benefits: [
            t("home.career.courses.benefits.0"),
            t("home.career.courses.benefits.1"),
            t("home.career.courses.benefits.2"),
            t("home.career.courses.benefits.3"),
          ],
          cards: [
            {
              ico: <GradIcon size="30" color="white" />,
              title: t("home.career.courses.cards.0.title"),
              text: t("home.career.courses.cards.0.text"),
            },
            {
              ico: <GradIcon size="30" color="white" />,
              title: t("home.career.courses.cards.1.title"),
              text: t("home.career.courses.cards.1.text"),
            },
            {
              ico: <GradIcon size="30" color="white" />,
              title: t("home.career.courses.cards.2.title"),
              text: t("home.career.courses.cards.2.text"),
            },
          ],
        };

      case "jobs":
        return {
          title: t("home.career.jobs.title"),
          desc: t("home.career.jobs.desc"),
          benefits: [
            t("home.career.jobs.benefits.0"),
            t("home.career.jobs.benefits.1"),
            t("home.career.jobs.benefits.2"),
            t("home.career.jobs.benefits.3"),
          ],
          cards: [
            {
              ico: <BriefcaseIcon size="26" color="white" />,
              title: t("home.career.jobs.cards.0.title"),
              text: t("home.career.jobs.cards.0.text"),
            },
            {
              ico: <BriefcaseIcon size="26" color="white" />,
              title: t("home.career.jobs.cards.1.title"),
              text: t("home.career.jobs.cards.1.text"),
            },
            {
              ico: <BriefcaseIcon size="26" color="white" />,
              title: t("home.career.jobs.cards.2.title"),
              text: t("home.career.jobs.cards.2.text"),
            },
          ],
        };

      case "profile":
        return {
          title: t("home.career.profile.title"),
          desc: t("home.career.profile.desc"),
          benefits: [
            t("home.career.profile.benefits.0"),
            t("home.career.profile.benefits.1"),
            t("home.career.profile.benefits.2"),
            t("home.career.profile.benefits.3"),
          ],
          cards: [
            {
              ico: <ProfileIcon size="23" color="white" />,
              title: t("home.career.profile.cards.0.title"),
              text: t("home.career.profile.cards.0.text"),
            },
            {
              ico: <ProfileIcon size="23" color="white" />,
              title: t("home.career.profile.cards.1.title"),
              text: t("home.career.profile.cards.1.text"),
            },
            {
              ico: <ProfileIcon size="23" color="white" />,
              title: t("home.career.profile.cards.2.title"),
              text: t("home.career.profile.cards.2.text"),
            },
          ],
        };

      default:
        return {};
    }
  };

  const { title, desc, benefits, cards } = renderContent();

  return (
    <section className="career-section">
      <div className="career-inner">
        <header className="career-header">
          <h2 className="career-title">
            {t("home.career.header.line1")}{" "}
            <span className="accent">{t("home.career.header.accent")}</span>
            <br />
            <span className="accent">{t("home.career.header.line2")}</span>
          </h2>
          <p className="career-sub">{t("home.career.header.sub")}</p>
        </header>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <nav className="career-tabs">
            <button
              className={`tab ${active === "courses" ? "active" : ""}`}
              onClick={() => handleTabChange("courses")}
            >
              <GradIcon size={22} color={active === "courses" ? "white" : "black"} />
              {t("home.career.tabs.courses")}
            </button>

            <button
              className={`tab ${active === "jobs" ? "active" : ""}`}
              onClick={() => handleTabChange("jobs")}
            >
              <BriefcaseIcon size={22} color={active === "jobs" ? "white" : "black"} />
              {t("home.career.tabs.jobs")}
            </button>

            <button
              className={`tab ${active === "profile" ? "active" : ""}`}
              onClick={() => handleTabChange("profile")}
            >
              <ProfileIcon size={22} color={active === "profile" ? "white" : "black"} />
              {t("home.career.tabs.profile")}
            </button>
          </nav>
        </div>

        <div className="career-main">
          <div className="career-media">
            <div className="video-placeholder">
              <div className="video-layer">
                {showThumbnail && (
                  <div
                    className="video-thumb"
                    role="button"
                    tabIndex={0}
                    onClick={handlePlay}
                    onKeyDown={(e) => e.key === "Enter" && handlePlay()}
                  >
                    <img src={thumbnails[active]} alt="Video preview" />

                    {/* overlay */}
                    <div className="video-overlay" />

                    {/* play button */}
                    <div className="play-btn">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                )}

                <video
                  ref={videoRef}
                  className="video-element"
                  src={videoLinks[active]}
                  controls
                  playsInline
                  preload="metadata"
                />
              </div>
            </div>
          </div>

          <aside className="career-info">
            <div
              className={`career-info-panel ${
                direction === "right" ? "slide-in-right" : "slide-in-left"
              }`}
            >
              <h3>{title}</h3>
              <p className="career-info-desc">{desc}</p>

              <ul className="benefits-list">
                {benefits.map((item, i) => (
                  <li key={i}>
                    <TickIcon />
                    {item}
                  </li>
                ))}
              </ul>

              <button className="btn-primary-career" onClick={handleLearnMore}>
                {t("home.career.learnMore", "Learn More")}
              </button>
            </div>
          </aside>
        </div>

        <div className="card-row">
          {cards.map((card, i) => (
            <article className="mini-card" key={i}>
              <div className="mini-ico">{card.ico}</div>
              <h4>{card.title}</h4>
              <p>{card.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
